import Axios from 'axios'

export const searchSuggestedProducts = async (params) => {
  const response = await Axios.post('/suggestedProducts/search', params)
  return response.data
}

export const createSuggestedProduct = async (formData) => {
  const response = await Axios.post('/suggestedProducts/create', formData)
  return response.data
}

export const updateSuggestedProduct = async ({ id, params }) => {
  const response = await Axios.put(`/suggestedProducts/update?id=${id}`, params)
  return response.data
}

export const deleteSuggestedProduct = async (id) => {
  const response = await Axios.delete(`/suggestedProducts/delete?id=${id}`)
  return response.data
}

export const searchSuggestedProductsByClient = async ({ page, pageSize, displayLocation } = {}) => {
  const response = await Axios.get('/suggestedProducts/searchByClient', { params: { page, pageSize, displayLocation } })
  return response.data
}

export const getSpecialties = async () => {
  const response = await Axios.get('/suggestedProducts/specialties')
  return response.data
}
